module.exports = __webpack_public_path__ + "img/soya-sauce.9eabc837.jpg";